import PropTypes from 'prop-types';
import React from 'react';

import BreederProfileFamilyOverlay, {
  imageDimensions
} from 'dpl/components/BreederProfile/Show/BreederProfileFamilyOverlay';
import MediaCarousel from 'dpl/components/MediaCarousel';
import OverlayNavigationArrow from 'dpl/components/OverlayNavigationArrow';
import { ShelterDogPropTypes } from 'dpl/shared/utils/customPropTypes';

export default function DetailsDogModal({
  address,
  dog,
  nextDog,
  onClose,
  onDogClick,
  previousDog
}) {
  return (
    <BreederProfileFamilyOverlay onClose={onClose}>
      <div className="flex items-center justify-between pv4 ph4">
        <p className="truncate">{dog.name}</p>
        <p className="fw-medium">{address}</p>
      </div>
      <div className="relative bg-black">
        {previousDog && (
          <OverlayNavigationArrow
            direction="left"
            onClick={() => onDogClick(previousDog.id)}
          />
        )}

        {dog.photographs.length > 0 ? (
          <MediaCarousel
            files={dog.photographs}
            showArrowsOnHover
            dimensions={imageDimensions}
            smartImageProps={{
              Tag: 'div',
              className: 'contain bg-center mw-100 min-w-100',
              loadingClass: 'bg-loading-animation'
            }}
          />
        ) : (
          <div className="bg-gray-200" style={imageDimensions} />
        )}

        {nextDog && (
          <OverlayNavigationArrow
            direction="right"
            onClick={() => onDogClick(nextDog.id)}
          />
        )}
      </div>
      <div className="ph5 ph6-sm pv6">
        <p className="pre-wrap">{dog.description}</p>
      </div>
    </BreederProfileFamilyOverlay>
  );
}

DetailsDogModal.propTypes = {
  address: PropTypes.string.isRequired,
  dog: PropTypes.shape(ShelterDogPropTypes).isRequired,
  nextDog: PropTypes.shape(ShelterDogPropTypes),
  onClose: PropTypes.func.isRequired,
  onDogClick: PropTypes.func.isRequired,
  previousDog: PropTypes.shape(ShelterDogPropTypes)
};

DetailsDogModal.defaultProps = {
  nextDog: null,
  previousDog: null
};
